import React from "react";
import PrimaryButton from "../buttons/PrimaryButton.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import Box1 from "../boxs/Box1.js";
import Row from "../layout/Row.js";
import StackBottomRight from "../layout/StackBottomRight.js";
import PasswordField from "../textfields/PasswordField.js";
import EmailField from "../textfields/EmailField.js";
import { Player } from "@lottiefiles/react-lottie-player";

import GreyButton from "../buttons/GreyButton.js";
import RoundedButton from "../buttons/RoundedButton.js";
import Space from "../layout/Space.js";
import HexagoneHeader from "../hexagone/HexagoneHeader.js";

import { useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";
import { loginUser } from "../auth/FirebaseAuth.js";
import { useSnackbar } from "notistack";
import ConfirmationSmsModal from "../modals/ConfirmationSmsModal.js";
import { VerifySmsCodeCall } from "../config/ApiCalls.js";
import { gatherDeviceInfo } from "../config/GatheringInfos.js";
import Modal1 from "../modals/Modal1.js";
import TextField2 from "../textfields/TextField2.js";
import {
  queryCollection,
  updateDocDataField,
} from "../models/DataFunctions.js";

import { useAppContext } from "../config/AppContext.js";
import sendPasswordResetEmailNoAuth from "../api/send/sendPasswordEmailNoAuth.js";
import { useEffect } from "react";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import loadingAnimation from "../animations/loading.json"; // Path to your JSON file
import { Icon } from "@mui/material";
import HexagoneTitle from "../hexagone/HexagoneTitle.js";
import Icon1 from "../icons/Icon.js";
import sendLoginPortalCallBack from "../api/auth/sendLoginPortalCallBack.js";

function LoginPartner({ text, action }) {
  const [searchParams] = useSearchParams();
  const external_id = searchParams.get("external_id");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [code, setCode] = useState("");

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const login_security = appState.login_security;

  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true); // Open modal
  const handleClose = () => setOpen(false); // Close modal

  const [loading, setLoading] = useState(false);

  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const handleFetchData = async () => {
    if (login_security && login_security.end_date) {
      let end_date = login_security.end_date;
      let current_date = new Date().getTime();
      if (current_date < end_date) {
        setTooManyAttempts(true);
        setTimeLeftToWait(end_date - current_date);
      }
    }
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  const handlepdateLoginSecurity = () => {
    let new_login_security = login_security ? login_security : {};
    let attempts = new_login_security.attempts
      ? new_login_security.attempts
      : 0;
    new_login_security.attempts = attempts + 1;
    // set folders_config
    setAppState((prevState) => ({
      ...prevState,
      login_security: new_login_security,
    }));
    if (new_login_security.attempts > 3) {
      setTooManyAttempts(true);
      setTimeLeftToWait(waitTime); // Set the wait time to 30 seconds
      let end_date = new Date().getTime() + waitTime;
      new_login_security.end_date = end_date;
      // set folders_config
      setAppState((prevState) => ({
        ...prevState,
        login_security: new_login_security,
      }));
    }
  };

  const [tooManyAttempts, setTooManyAttempts] = useState(false);
  const [timeLeftToWait, setTimeLeftToWait] = useState(0); // in milliseconds
  const waitTime = 60000; // 30 seconds wait time

  useEffect(() => {
    if (tooManyAttempts && timeLeftToWait > 0) {
      const countdown = setInterval(() => {
        setTimeLeftToWait((prev) => prev - 1000); // Decrement every second
      }, 1000);

      return () => clearInterval(countdown); // Cleanup interval on component unmount or when timer ends
    }

    if (timeLeftToWait <= 0 && tooManyAttempts) {
      // Timer finished, reset attempts and re-enable login
      setTooManyAttempts(false);
    }
  }, [tooManyAttempts, timeLeftToWait]);

  const handleModal = async (event) => {
    setLoading(true);
    event.preventDefault();
    try {
      if (!email || !password) {
        setLoading(false);
        handleClickVariant("Entrez votre email et votre mot de passe", "error"); // Error notification
        throw new Error("Email and password are required");
      }

      await handleLoginPartner(event);
    } catch (error) {
      handleClickVariant("Identifiants erronés", "error"); // Error notification
      console.error("Error logging in:", error.message);
      handle;
      setError(error.message); // Handle and display the error
    } finally {
      // Ensure that loading is stopped no matter what happens
    }
    setLoading(false);
  };

  const [success, setSuccess] = useState(false);

  const handleLoginPartner = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      let success = await sendLoginPortalCallBack(
        email,
        password,
        external_id,
        prefix
      );
      setSuccess(success);
      if (success) {
        handleClickVariant("Connexion réussie", "success"); // Success notification
      } else {
        handleClickVariant("Identifiants erronés", "error"); // Error notification
        handlepdateLoginSecurity();
      }
    } catch (error) {
      handleClickVariant("Identifiants erronés", "error"); // Error notification
      console.error("Error logging in:", error.message);
      setError(error.message); // Handle and display the error
    }
    setLoading(false);
  };

  const [forgotOpen, setForgotOpen] = useState(false);
  const [email_value, setEmailValue] = useState("");

  return (
    <div className="h-screen">
      <div className="h-full  items-center flex justify-center flex-col">
        <Box1>
          <div className="flex justify-center items-center">
            <Icon1 icon_name="hexagone" width="30px" height="40px" />
            <div className=" justify-center items-center px-2 py-2 text-hx2 font-black text-black ">
              hexagone{" "}
              <span className="text-shadow_50 inline-block"> partner</span>
            </div>
          </div>
          <Space y={10} />
          {!loading && success === false && (
            <form onSubmit={handleModal}>
              <div className="flex flex-col gap-1 items-center">
                <EmailField
                  label={"Email"}
                  sx={{ width: "300px" }}
                  value={email}
                  onChange={(e) => {
                    setEmail(
                      e.target.value.startsWith(" ")
                        ? e.target.value.trimStart()
                        : e.target.value
                    );
                  }}
                />
                <Space y={5} />

                <PasswordField
                  sx={{ width: "300px" }}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <Space y={10} />
                {tooManyAttempts && timeLeftToWait > 0 && (
                  <div className="text-h3 text-shadow_50 max-w-c250 text-center">
                    Temps restant avant de pouvoir réessayer:{" "}
                    {Math.floor(timeLeftToWait / 1000)} secondes
                  </div>
                )}

                <Space y={10} />

                <RoundedButton
                  disabled={tooManyAttempts && timeLeftToWait > 0}
                  type="submit"
                  color="black"
                  loading={loading}
                  className="w-fit "
                >
                  Se Connecter
                </RoundedButton>
              </div>
            </form>
          )}

          {loading && (
            <Player
              autoplay
              loop
              src={loadingAnimation}
              style={{ height: "100px", width: "200px" }}
            />
          )}
          {success && (
            <div className="flex flex-col gap-1 items-center  w-c300">
              <div className="flex flex-row gap-2 items-center ">
                <Icon1 icon_name="done2" size={35} fill="#13ea7f" />
              </div>
              <div className=" flex-row  items-center mt-3  text-shadow_50 text-h2">
                <span className="font-semibold">Finalisez la connexion </span>
              </div>
              <div className=" flex-row  items-center   text-shadow_50 text-h2">
                sur l'outil partenaire
              </div>
            </div>
          )}
          <Space y={10} />
        </Box1>
      </div>
    </div>
  );
}

export default LoginPartner;
